<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    align: {
      type: String,
      default: 'right',
      validator(value) {
        return ['left', 'center', 'right'].includes(value);
      },
    },
    direction: {
      type: String,
      default: 'horizontal',
      validator(value) {
        return ['horizontal', 'vertical'].includes(value);
      },
    },
    spacing: {
      type: String,
      default: 'blaster',
      validator(value) {
        return ['blaster', 'giga', 'none'].includes(value);
      },
    },
    borderless: {
      type: Boolean,
      default: false,
      required: false,
    },

    variant: {
      type: String,
      required: false,
    },
  });

  const variant = computed(() => window.CREDERE.variants?.section || props.variant);

  const classes = computed(() => ({
    'credere-buttons': true,
    'variant--borderless': props.borderless,
    [`variant--buttons-1${variant.value?.toLowerCase()}`]: variant.value,

    [`align--${props.align}`]: true,
    [`direction--${props.direction}`]: true,
    [`spacing--${props.spacing}`]: true,
  }));
</script>

<template>
  <section :class="classes">
    <slot />
  </section>
</template>

<style lang="scss">
  .credere-buttons {
    --border-color: var(--token-color-constant-dark);
    --border-style: solid;
    --border-width: var(--token-border-width-thin) 0 0 0;
    --gap: var(--token-spacing-xxs);

    // align-items: <BELLOW>
    display: flex;
    // flex-direction: <BELLOW>
    flex-wrap: wrap;
    // justify-content: <BELLOW>
    // margin: <BELLOW>
    // padding: <BELLOW>

    @container (max-width: 768px) {
      align-items: stretch;
      flex-direction: column;
      justify-content: flex-start;
    }

    &.direction--horizontal {
      align-items: flex-start;
      flex-direction: row;

      @container (max-width: 768px) {
        align-items: stretch;
        flex-direction: column;
      }
    }

    &.direction--vertical {
      align-items: stretch;
      flex-direction: column;
    }

    &.align--left {
      justify-content: flex-start;
    }

    &.align--center {
      justify-content: center;
    }

    &.align--right {
      justify-content: flex-end;
    }

    &.spacing--blaster {
      --margin: var(--token-spacing-blaster) 0 0 0;
      --padding: var(--token-spacing-blaster) 0 0 0;
    }

    &.spacing--giga {
      --margin: var(--token-spacing-giga) 0 0 0;
      --padding: var(--token-spacing-giga) 0 0 0;
    }

    &.variant--borderless {
      --border-width: 0;
    }

    &.variant--buttons-1b {
      --border-radius: var(--token-border-radius-decorative);
      --border-color: var(--token-color-neutral-light);
      --border-style: solid;
      --border-width: var(--token-border-width-soft);
      --background-color: var(--token-color-constant-light);
      --box-shadow: var(--token-box-shadow-around-2);
      --margin: var(--token-spacing-xl) 0 0 0;
      --padding: var(--token-spacing-xl);
    }
  }
</style>
